export default __webpack_public_path__ + "static/media/loginTB.40ea7fec.jpg";